<template>
  <div class="map-container" :class="{hidden : hidden, eventsMap: !isExplore}"
  @click="$store.dispatch('unselectGeometry')"
  >
    <div id="map"></div>
    <div v-if="isDev && !$store.state.isMobile" id="debug"><b>[debug]</b>
      <br> zoom_{{ debug.zoom }}
      <br> lat_{{ Math.round(debug.center.lat * 100) / 100 }}
      <br> lng_{{ Math.round(debug.center.lng * 100) / 100 }}
      <div v-if="currentEvent"> <b>current date:</b> {{currentEvent.date}} </div>
      <br> <b>geometries (id, creation, expiration)</b>
      <div v-if="debug.features">
        <div  v-for="(feature, index) in debug.features" :key="index">- {{ feature ? feature.join(', ') : '' }}</div>
      </div>
      <div v-if="selectedGeometry"> <b>selected:</b> {{selectedGeometry}} </div>
    </div>
  </div>
</template>

<script>
import LeafletMap from '@/lib/LeafletMap'
import { toDecimalDate } from '@/lib/dataFormatter'
import { isAnimal } from '@/lib/FeatureFilters'

export default {
  name: 'Map',
  props: ['currentScreenId', 'hidden', 'isExplore', 'locale'],
  data () {
    return {
      features: this.$store.state.mapData,
      events: this.$store.getters.storyData,
      debug: { features: '', zoom: process.env.VUE_APP_MAP_ZOOM, center: { lat: process.env.VUE_APP_MAP_CENTER_LAT, lng: process.env.VUE_APP_MAP_CENTER_LNG } },
      visibleFeatures: [],
      highlightFeatures: [],
      zoom: 6,
      isDev: process.env.NODE_ENV === 'development'
    }
  },
  computed: {
    selectedGeometry () {
      return this.$store.state.selectedGeometry
    },
    currentEvent () {
      return this.events.find(event => event.slug === this.currentScreenId)
    }

  },
  mounted () {
    console.log('mounted')
    global.leafletMap = new LeafletMap('map', this.features, this.$store, this.isExplore)
    global.features = this.features
    if (this.isExplore) {
      global.leafletMap.map.flyTo([ 69.51, -80.44 ], 6)
      global.leafletMap.map.scrollWheelZoom.enable()
      this.visibleFeatures = this.features.filter(feature => feature.geometry.type === 'Point')
        .filter(feature => !isAnimal(feature))
      this.highlightFeatures = []
      global.leafletMap.loadHighlightLayer(this.highlightFeatures)
      global.leafletMap.loadEventLayer(this.visibleFeatures)
      global.leafletMap.updateEventLayerTooltips()
    }
    global.leafletMap.map.on('zoomend', (e) => {
      const zoom = e.target.getZoom()
      if (global.zoom === zoom) return
      global.zoom = zoom
      if (zoom > 15) global.leafletMap.map.setZoom(15)
      this.debug.zoom = zoom
      global.leafletMap.updateIconSizes(zoom)
      global.leafletMap.loadEventLayer(this.visibleFeatures)
      // global.leafletMap.updateStaticLayers(zoom)
      global.leafletMap.updateEventLayerTooltips()
      if (this.$store.state.selectedGeometry) {
        global.leafletMap.focusOnMarker(this.$store.state.selectedGeometry.id)
      }
    })
    global.leafletMap.map.on('moveend', (e) => {
      this.debug.center = e.target.getCenter()
    })
  },
  watch: {
    currentScreenId (newValue, oldValue) {
      const currentEvent = this.currentEvent

      if (this.currentEvent) {
        global.leafletMap.map.scrollWheelZoom.disable()
        this.visibleFeatures = this.FeaturesByEvent(currentEvent)
        global.leafletMap.loadEventLayer(this.visibleFeatures)
        global.leafletMap.updateEventLayerTooltips()
        this.highlightFeatures = this.features.filter(feature => {
          return currentEvent.geometryids.includes(parseInt(feature.properties.geometry_id)) || currentEvent.geometryids.includes(parseInt(feature.properties.geometryid))
        })
        this.debug.features = this.highlightFeatures.map(feature => ([
          feature.properties.geometry_id,
          feature.properties.iconcreation,
          feature.properties.iconexpiration
        ])) // .join(', ')
        global.leafletMap.loadHighlightLayer(this.highlightFeatures)
        const { zoom, lat, lng } = currentEvent
        if (zoom && lat && lng) {
          global.leafletMap.map.flyTo([parseFloat(lat), parseFloat(lng)], parseInt(zoom))
        } else {
          global.leafletMap.map.setZoom(7)
        }
      } else {
        global.leafletMap.map.flyTo([ 69.51, -80.44 ], 6)
        global.leafletMap.map.scrollWheelZoom.enable()
        this.visibleFeatures = this.features.filter(feature => feature.geometry.type === 'Point')
          .filter(feature => !isAnimal(feature))
        this.highlightFeatures = []
        global.leafletMap.loadHighlightLayer(this.highlightFeatures)
        global.leafletMap.loadEventLayer(this.visibleFeatures)
        global.leafletMap.updateEventLayerTooltips()
      }
    },
    selectedGeometry (newValue) {
      if (!newValue) {
        global.leafletMap.loadEventLayer(this.visibleFeatures)
        global.leafletMap.updateEventLayerTooltips()
        if (this.$store.state.eventId !== 'explore-the-land') {
          global.leafletMap.map.scrollWheelZoom.disable()
        }
      } else {
        global.leafletMap.map.scrollWheelZoom.enable()
      }
    }
  },
  methods: {
    FeaturesByEvent (currentEvent) {
      return this.features
        .filter(feature =>
          feature.geometry.type === 'Point'
          // && feature.properties.icon
          // && (feature.properties['Name RN'] || feature.properties['Name IN'])
        )
        .filter(feature => !isAnimal(feature))
        .filter(feature => {
          const dateMin = feature.properties.iconcreation ? toDecimalDate(feature.properties.iconcreation) : 0
          const dateMax = feature.properties.iconexpiration ? toDecimalDate(feature.properties.iconexpiration) : 2020
          const currentEventDate = toDecimalDate(currentEvent.date)
          return currentEventDate >= dateMin && currentEventDate <= dateMax
        })
    }
  }
}
</script>

<style lang="scss">
#debug {
    position: absolute;
    top: 10px;
    right: 10px;
    width: 300px;
    height: 400px;
    border: solid;
    padding: 10px;
    pointer-events: auto;
}
.map-container {
  opacity: 1;
  transition: opacity 2s;
}
.map-container.hidden {
  opacity: 0
}
.map-container.eventsMap {
  @media only screen and (max-width: 768px) {
      opacity: 0;
  }
}
</style>
